import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    params: {}
  },
  mutations: {
    GetRouteParams(state,obj) {
     
      state[obj.paramsName]=obj.paramsV;
      
    }
  },
  actions: {
    TriggerGetParams({ commit },obj) {
     
      commit('GetRouteParams', obj)
    }
  }
})
